import { sendServerMessage } from "./serverMessaging";

export const getSalesStartedForKiosk = id =>
  sendServerMessage({
    type: "StatsForKiosk",
    id,
  });

export const getSalesForPeriodByStation = stationId =>
  sendServerMessage({
    type: "SalesPerHourStation",
    stationId,
    hours: 6,
  });

export const getTodaysKioskSalesPerStation = stationId =>
  sendServerMessage({
    type: "SalesKioskTodayStation",
    stationId,
  });

export const getAlertsForKiosk = kioskId =>
  sendServerMessage({
    type: "AlertsForKiosk",
    kioskId,
  });



// WEBPACK FOOTER //
// ./src/lib/dataQueries.js